import React from "react";
import { useForm, FormContext } from "react-hook-form";
import { Button, Grid } from "@material-ui/core";
import axios from "axios";
import FormDireccion from "./Direccion";
import FormDestinatario from "./Destinatario";

import { useAuth0 } from "../../../hooks/react-auth0-spa";
import { API_URL } from "../../../constants/constants";
const FormDirecciones = ({doPost}) => {

  const methods = useForm();
  const { getTokenSilently, user } = useAuth0();
  const onSubmit = async data => {
    const {estado,pais,cp,calle,numero,colonia,delegacion,referencia
          ,nombre,correo,telefono,empresa}=data;
    const t = await getTokenSilently();
    const r = await axios.post(
      API_URL + `/destinatarios/${user.sub}`,
      {
        nombre,
        correo,
        telefono,
        empresa
      },
      {
        headers: {
          // "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${t}`
        }
      }
    );
    const Direccion={
      estado:estado.value,
      pais,
      cp,
      calle,
      numero,
      colonia,
      delegacion,
      referencia,
      destinatario:r.data._id
    }
    doPost(Direccion);
  };

  return (
    <FormContext {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container spacing={2} >
          <Grid item xs={12} sm={12} md={6}>
          <FormDestinatario />
            
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <FormDireccion />
          </Grid>
          <Button variant="contained" color="primary" type="submit">
            AGREGAR
          </Button>
        </Grid>
      </form>
    </FormContext>
  );
};

export default FormDirecciones;
